// @flow
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'

type Props = {
  children: Function,
}

function FormBuilderSettingsNotificationsFormConsumer({
  children,
}: Props): React.Node {
  const { notificationUsers, setNotificationUsers, setIsDirty } =
    React.useContext(FormBuilderContext)

  return children({ notificationUsers, setNotificationUsers, setIsDirty })
}

export default FormBuilderSettingsNotificationsFormConsumer
